const _findInPrevious = (currentField, previousFieldsData) => {
  return previousFieldsData.find((pf) => currentField.componentRef.id === pf.componentRef.id)
}

export const getOnStageFieldsData = (
  currentFieldsData,
  previousFieldsData,
): { componentRef: ComponentRef; data: ComponentData }[] =>
  currentFieldsData.map((cf) => _findInPrevious(cf, previousFieldsData) || { ...cf, data: {} })
